<template>
    <div class="menu-container">
        <ul class="menu-list">
            <li class="menu-item" v-for="(item, i) in navList" :key="i"  @click="clickMenu(item)"  :class="{'active': currentMenuName == item.name}">
                <div class="menu-content">
                    <div class="menu-icon">
                        <i :class="['iconfont ', [item.icon]]"></i>
                    </div>
                    <div class="menu-inner">
                        {{ item.title }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'asideMenu',
  data () {
    return {
      selectMenuName: null,
      navList: [
        { title: '统计分析', icon: 'icon-tongjifenxi', path: 'analysis', name: 'analysis' },
        { title: '地块管理', icon: 'icon-dikuaiguanli', path: 'land', name: 'land' },
        { title: '用户管理', icon: 'icon-yonghuguanli', path: 'user', name: 'user' },
        { title: '平台公司管理', icon: 'icon-qiye', path: 'platform', name: 'platform' },
        { title: '招商联系人管理', icon: 'icon-zhaoshanglianxiren', path: 'merchants', name: 'merchants' },
        { title: '常见问题管理', icon: 'icon-changjianwenti1', path: 'problem', name: 'problem' },
        { title: '政策法规管理', icon: 'icon-zhengcefagui1', path: 'regulations', name: 'regulations' }

      ]
    }
  },
  create () {
    //
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const registerType = localStorage.registerType
      if (registerType === '0' || registerType === '1') {
        this.navList = [
          { title: '统计分析', icon: 'icon-tongjifenxi', path: 'analysis', name: 'analysis' },
          { title: '地块管理', icon: 'icon-dikuaiguanli', path: 'land', name: 'land' }
        ]
      }
    },
    clickMenu (data) {
      if (data.name === this.$route.name) return
      this.$router.push({
        name: data.name
      })
    }
  },
  computed: {
    currentMenuName: {
      get () {
        return this.$route.name
      },
      set (val) {
        this.selectMenuName = val
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .menu-container {
        width: 98px;
        height: 100%;
        padding-bottom: 30px;
        background: #283B5C;
        box-sizing: border-box;
        ul, li {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        li {
            padding: 0 10px;
            color: rgba(255, 255, 255, .8);
            text-align: center;
            cursor: pointer;
            box-sizing: border-box;
            &:hover, &.active {
                color: #fff;
                background: #2789EE;
                .menu-conten {
                    border-bottom: solid 1px #2789EE;
                }
            }
            .menu-content {
                padding: 18px 0;
                border-bottom: solid 1px #3E4F6C;
                box-sizing: border-box;
                .menu-icon {
                    margin-bottom: 8px;
                    > i {
                        font-size: 28px;
                    }
                }
                .menu-inner {
                    line-height: 20px;
                    padding: 0 6px;
                    font-size: 16px;
                }
            }
        }
    }
</style>
